import { Styles } from '@core/utils/css';
import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import './header.scss';

export const PublicDashboardHeader = memo(() => {
  return (
    <React.Fragment>
      <header id="page-topbar" className="shadow-none">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={Styles.assets('images/yesa.png')} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={Styles.assets('images/yesa.png')} alt="" height="30" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={Styles.assets('images/yesa.png')} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={Styles.assets('images/yesa.png')} alt="" height="30" />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
});
